<template>
    <div class="details-page">
        <div :class="['ai-nav-head', isScroll ? 'scroll': null]">
            <div style="width: 1424px; margin: 0 auto;">
                <div class="ai-nav-search">
                    <div class="ai-page-title">{{ $i18n.t('algorithm.pageTitle') }}</div>
                    <!-- <div class="search-box">
                        <el-input placeholder="Please input" class="search"></el-input>
                        <div class="button">Search</div>
                    </div>
                    <div style="width: 100px;"></div> -->
                </div>
            </div>
        </div>
        <div class="details-body">
            <div class="details">
                <div class="text">
                    <div class="text-img">
                        <img :src="gorithms.cover" alt=""/>
                    </div>
                    <div class="text-content">
                        <div class="text-content-title">
                            {{ gorithms.name }}
                        </div>
                        <div class="supplier">
                            <span>{{ $i18n.t(`algorithm.details['Service Provider']`) }}: </span><span>{{ gorithms.serviceProvider }}</span>
                        </div>
                        <div class="text-content-introductory">
                            {{ gorithms.intro }}
                        </div>
                    </div>
                    <div class="details-button" v-if="gorithms.shelves">
                        <div class="title">
                            <div class="top">
                                The algorithm is applicable to: Model: {{ gorithms.applicableTo }}
                            </div>
                            <div class="bottom">
                                Click Try Now and fill in the application form. Ater verification, we will contact you via email.
                            </div>
                        </div>
                        <div class="button" @click="toPage">Try Now</div>
                    </div>
                </div>
                <div class="video">
                    <div class="video-content">
                        <video v-if="selectedData.type === 'video'" controls="controls" controlslist="nodownload" :src="selectedData.src" :poster="selectedData.cover" class="ho-video-demos"></video>
                        <img v-else :src="selectedData.src" alt=""/>
                    </div>
                    <div class="video-selector">
                        <div class="video-selector-options">
                            <div :class="{'option': true, 'active': index === selectedIndex}" v-for="(item, index) in medias" :key="index" @click="activeHander(item, index)">
                                <img :src="item.cover" alt=""/>
                            </div>
                        </div>
                    </div>
                    <div class="video-tags">
                        <div class="tag">
                            <i class="el-icon-chat-dot-round"></i> {{ $i18n.t(`algorithm.details['To contact service provider']`) }}
                        </div>
                        <div class="tag">
                            <i class="el-icon-document"></i> {{ $i18n.t(`algorithm.details['Service Provider Profile']`) }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="document">
                <div class="document-details">
                    <div :class="['point-nav', isFixed? 'fixed': '']">
                        <div :class="{'point-item':true, 'active': index === activeIndex}" v-for="(item, index) in point" :key="index" @click="pointHander(index)">
                            {{ $i18n.t(`algorithm.details.tags['${item}']`) }}
                        </div>
                    </div>
                    <div class="tips">
                        {{ $i18n.t(`algorithm.details['tips']`) }}
                    </div>
                    <ul class="queue">
                        <li class="ele" id="product-details">
                            <h3 class="big-title">
                                {{ $i18n.t(`algorithm.details.tags['Product Details']`) }}
                            </h3>
                            <h3 class="small-title">{{ $i18n.t(`algorithm.details.smallTags['Parameters']`) }}</h3>
                            <table class="attr-table">
                                <tr>
                                    <td colspan="2">
                                        <div class="table-item">
                                            <div class="lab">[Product Type]</div>
                                            <div class="table-info">{{ this.gorithmParams['Product Type'] }}</div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="table-item">
                                            <div class="lab">[Release Time]</div>
                                            <div class="table-info">{{ this.gorithmParams['Release Time'] }}</div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="table-item">
                                            <div class="lab">[Version Update]</div>
                                            <div class="table-info">{{ this.gorithmParams['Version Update'] }}</div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="table-item">
                                            <div class="lab">[Application Scenario]</div>
                                            <div class="table-info">{{ this.gorithmParams['Application Scenario'] }}</div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="table-item">
                                            <div class="lab">[Algorithm Type]</div>
                                            <div class="table-info">{{ this.gorithmParams['Algorithm Type'] }}</div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="table-item">
                                            <div class="lab">[Applicable Product]</div>
                                            <div class="table-info">{{ this.gorithmParams['Applicable Product'] }}</div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="table-item">
                                            <div class="lab">[Key Specifications]</div>
                                            <div class="table-info">{{ this.gorithmParams['Key Specifications'] }}</div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div class="table-item">
                                            <div class="lab">[Description]</div>
                                            <div class="table-info">{{ this.gorithmParams['Description'] }}</div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <h3 class="small-title">{{ $i18n.t(`algorithm.details.smallTags['Introduction']`) }}</h3>
                            <p v-for="(item, index) in introduction" :key="index">
                                {{ item }}
                            </p>
                            <h3 class="small-title">{{ $i18n.t(`algorithm.details.smallTags['Version']`) }}</h3>
                            <div>
                                <div class="version-tabs">
                                    <div :class="['tab', versIndex === index&&'active']" v-for="(item, index) in versionHeader" :key="index" @click="versionSelectAction(item)">{{ item }}</div>
                                </div>
                                <table class="sence-table">
                                    <tr>
                                        <th class="lab">Version Number/Update Time</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr v-for="(item, index) in versionSelected" :key="index">
                                        <td class="lab">
                                            <div>{{ item.versionNum }}</div>
                                            <div class="version-time">{{ item.versionUpdateDate }}</div>
                                        </td>
                                        <td>{{ item.content }}</td>
                                    </tr>
                                </table>
                            </div>
                            <h3 class="small-title">{{ $i18n.t(`algorithm.details.smallTags['Highlights']`) }}</h3>
                            <div>
                                <ul class="advantages-tags">
                                    <li v-for="(item, index) in gorithmAdvantages" :key="index">
                                        <div :class="[`num${index+1}`, 'num']"></div>
                                        <p class="title">{{ item.title }}</p>
                                        <p class="desc">{{ item.content }}</p>
                                    </li>
                                </ul>
                            </div>
                            <h3 class="small-title">{{ $i18n.t(`algorithm.details.smallTags['Scenario Requirements']`) }}</h3>
                            <table class="sence-table">
                                <tr>
                                    <th class="lab">Type</th>
                                    <th>Requirement</th>
                                </tr>
                                <tr v-for="(item, index) in gorithmConstraints" :key="index">
                                    <td class="lab">
                                        <div>{{ item.title }}</div>
                                    </td>
                                    <td>{{ item.content }}</td>
                                </tr>
                            </table>
                            <h3 class="small-title">{{ $i18n.t(`algorithm.details.smallTags['Graphic presentation']`) }}</h3>
                            <img v-for="(item, cindex) in gorithmGraphics" :key="cindex+'a'" :src="item.graphicSrc" alt="" style="width: 100%;"/>
                        </li>
                        <li class="ele" id="related-products">
                            <!-- <h3 class="big-title">
                                {{ $i18n.t(`algorithm.details.tags['Associated Product']`) }}
                            </h3> -->
                            <!-- <h3 class="small-title">{{ $i18n.t(`algorithm.details.smallTags['Solution with this algorithm']`) }}</h3>
                            <p>{{ $i18n.t(`algorithm.details['update tips']`) }}</p>
                            <h3 class="small-title">
                                {{ $i18n.t(`algorithm.details.smallTags['Supporting Applications']`) }}
                            </h3> -->
                            <div>
                                <ul class="apps">
                                    <li class="app" v-for="(item, index) in supporApps" :key="index">
                                        <img :src="item.iconSrc" alt="" style="width: 80px; height: 80px;">
                                        <div>
                                            <p class="title">{{ item.title }}</p>
                                            <p class="desc">
                                                Service Provider: {{ item.serviceProvider }}
                                            </p>
                                            <p class="desc">
                                                Introduction: {{ item.content }}
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <!-- <li class="ele" id="user-cases">
                            <h3 class="big-title">{{ $i18n.t(`algorithm.details.tags['Customer Case']`) }}</h3>
                            <p>{{ $i18n.t(`algorithm.details['update tips']`) }}</p>
                        </li>
                        <li class="ele" id="user-review">
                            <h3 class="big-title">{{ $i18n.t(`algorithm.details.tags['Customer Evaluation']`) }}</h3>
                            <p>{{ $i18n.t(`algorithm.details['update tips']`) }}</p>
                        </li>
                        <li class="ele" id="user-manual-and-review">
                            <h3 class="big-title">{{ $i18n.t(`algorithm.details.tags['Support']`) }}</h3>
                            <h3 class="small-title">{{ $i18n.t(`algorithm.details.smallTags['User Manual']`) }}</h3>
                            <p>{{ $i18n.t(`algorithm.details['update tips']`) }}</p>
                        </li> -->
                    </ul>
                </div>

                <div class="additional-list">
                    <div class="title">Company</div>
                    <div class="company-logo">
                        <img :src="iconSrc" alt="">
                    </div>
                    <div class="recommend-list">
                        <a :href="`https://www.holowits.com/algorithm-details-page/${item.id}`" target="_blank" class="recommend-item" v-for="(item, index) in moreList" :key="index">
                            <div class="recommend-item-img">
                                <img :src="item.cover" alt="">
                            </div>
                            <div class="recommend-item-content">
                                <div class="recommend-item-title">
                                    <p :title="item.name">{{ item.name }}</p>
                                </div>
                                <div class="recommend-item-introductory" :title="item.intro">{{ item.intro }}</div>
                            </div>
                        </a>
                    </div>
                </div>

                <div class="additional-list">
                    <div class="title">{{ $i18n.t('algorithm.recommendation') }}</div>
                    <div class="recommend-list">
                        <a href="https://www.holowits.com/product-center/detail/IVS/03353WAM" target="_blank" class="recommend-item">
                            <div class="recommend-item-img">
                                <img src="https://resources.holowits.com.sg/algorithm-icon/e6c2f829f91c455798e902377e37f2de.png" alt="">
                            </div>
                            <div class="recommend-item-content">
                                <div class="recommend-item-title">
                                    <p title="HWT-IVS1800-C08-4T">HWT-IVS1800-C08-4T</p>
                                </div>
                                <div class="recommend-item-introductory" title="4T 64-channel 8-disk intelligent Micro Edge">4T 64-channel 8-disk intelligent Micro Edge</div>
                            </div>
                        </a>
                        <a href="https://www.holowits.com/product-center" target="_blank" class="recommend-item">
                            <div class="recommend-item-img">
                                <img src="https://resources.holowits.com.sg/algorithm-icon/e6c2f829f91c455798e902377e37f2de.png" alt="">
                            </div>
                            <div class="recommend-item-content">
                                <div class="recommend-item-title">
                                    <p title="HWT-IVS1800-C08-16T">HWT-IVS1800-C08-16T</p>
                                </div>
                                <div class="recommend-item-introductory" title="4T 64-channel 8-disk intelligent Micro Edge">16T 64-channel 8-disk intelligent Micro Edge</div>
                            </div>
                        </a>
                        <a href="https://www.holowits.com/product-center" target="_blank" class="recommend-item">
                            <div class="recommend-item-img">
                                <img src="https://resources.holowits.com.sg/algorithm-icon/e6c2f829f91c455798e902377e37f2de.png" alt="">
                            </div>
                            <div class="recommend-item-content">
                                <div class="recommend-item-title">
                                    <p title="HWT-IVS1800-C08-32T">HWT-IVS1800-C08-32T</p>
                                </div>
                                <div class="recommend-item-introductory" title="4T 64-channel 8-disk intelligent Micro Edge">32T 64-channel 8-disk intelligent Micro Edge</div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { details, findGorithmsByProvider, findIconSrcByProviderName } from '@/api/gorithmApi';
export default {
    name: 'WebsiteVueIndex',

    data() {
        return {
            id: null,
            isScroll: false,
            medias: [],
            selectedIndex: 0,
            selectedData: {},
            gorithms: {},
            gorithmAdvantages: [],
            gorithmAssets: [],
            gorithmConstraints: [],
            gorithmGraphics: [],
            gorithmParams: {},
            gorithmVersions: [],
            supporApps: [],
            point: ['Product Details', 'Associated Product', 'Customer Case', 'Customer Evaluation', 'Support'],
            activeIndex: 0,
            isFixed: false,
            introduction: [],
            versIndex: 0,
            versionHeader: [],
            versionSelected: [],
            moreList: [],
            iconSrc: ''
        };
    },

    mounted() {
        this.id = this.$route.params.id;
        this.getDetails().then(() => {
            if (this.medias.length) {
                this.selectedData = this.medias[0];
            }
            this.findGorithmsByProviderFun()
            this.findIconSrcByProviderNameFun()
        })
        // window.addEventListener('scroll', () => this.contentScroll(), false);
        let total = this.getPointNavTop()
        window.addEventListener('scroll', () => this.setPointNavFixed(total), false);
    },

    methods: {
        getPointNavTop() {
            let jump = document.getElementsByClassName('point-nav')
            // 获取需要滚动的距离
            let total = jump[0].offsetTop;
            return total;
        },
        setPointNavFixed(total) {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            this.isFixed = scrollTop >= total;
        },
        async findGorithmsByProviderFun() {
            const {data: {data, isSuccess}} = await findGorithmsByProvider(this.gorithms.serviceProvider)
            if (isSuccess) {
                this.moreList = data
            }
        },
        async findIconSrcByProviderNameFun() {
            const {data: {data, isSuccess}} = await findIconSrcByProviderName(this.gorithms.serviceProvider)
            if (isSuccess) {
                this.iconSrc = data
            }
        },
        async getDetails() {
            const {data: {data, isSuccess}} = await details(this.id)
            if (isSuccess) {
                this.gorithms = data.gorithms;
                this.gorithmAdvantages = data.gorithmAdvantages;
                this.medias = data.gorithmAssets;
                this.gorithmConstraints = data.gorithmConstraints;
                this.gorithmGraphics = data.gorithmGraphics;
                this.gorithmVersions = data.gorithmVersions;
                this.supporApps = data.supporApps
                data.gorithmParams.forEach(i => {
                    this.gorithmParams[`${i.name}`] = i.value.replace(/\\n/g, '↵')
                })
                this.introduction = data.gorithms.introduction.split('\\n')
                let head = []
                data.gorithmVersions.forEach(i => {
                    !head.includes(i.version)&&head.push(i.version)
                })
                this.versionHeader = head;
                this.versionSelectAction(head[0])
            }
        },
        versionSelectAction(version) {
            let versionSelected = []
            this.gorithmVersions.forEach(i => {
                if (version === this.versionHeader[0]) {
                    versionSelected.push(i)
                }
            })
            this.versionSelected = versionSelected;
        },
        toPage() {
            this.$router.push({
                path: '/contactus'
            })
        },
        contentScroll(e) {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            this.isScroll = scrollTop >= 100;
        },
        activeHander(item, index) {
            this.selectedIndex = index;
            this.selectedData = item;
        },
        jump(index) {
            let jump = document.querySelectorAll('.ele')
            // 获取需要滚动的距离
            let total = jump[index].offsetTop;
            // Chrome
            document.body.scrollTop = total - 120;
            // Firefox
            document.documentElement.scrollTop = total - 120;
            // Safari
            window.pageYOffset = total - 120;
        },
        pointHander(value) {
            this.activeIndex = value
            this.jump(value)
        },
    },

    destroyed() {
        // window.removeEventListener('scroll', () => this.contentScroll());
        window.removeEventListener('scroll', () => this.setPointNavFixed());
        // window.removeEventListener('scroll', () => this.watchActive());
    }
};
</script>
<style>
    #navbar-wrapper {
        transition: 0s ease !important;
    }
    .page-on-scroll .navbar {
        border-bottom: 0px solid rgb(230 239 243) !important; 
    }
</style>
<style lang="less" scoped>
    .details-page {
        background-color: #f7f7f7;
        // height: 100vh;
    }
    .scroll {
        top: 65px !important;
    }
    .details-body {
        width: 1410px;
        margin: 0 auto;
        padding-top: 90px;
        padding-bottom: 40px;
    }
    .document {
        margin-top: 20px;
        width: 100%;
        overflow: hidden;

        .document-details {
            float: left;
            width: calc(100% - 290px);
            background-color: #FFFFFF;
            .point-nav {
                height: 55px;
                .point-item {
                    display: inline-block;
                    height: 55px;
                    line-height: 55px;
                    font-size: 16px;
                    &.point-item {
                        margin-left: 30px;
                    }
                    &.active {
                        border-bottom: 2px solid #d30303;
                        font-weight: 600;
                    }
                }
            }
            .fixed {
                position: fixed;
                user-select: none;
                z-index: 1;
                // top: 118px;
                top: 153px;
                width: calc(1410px - 290px);
                background-color: #FFFFFF;
                cursor: pointer;
                box-shadow: 0px 3px 2px #cccccc40;
            }
            .tips {
                margin: 20px;
                padding: 20px;
                background-color: #FBF2E3;
            }
        }
        .queue {
            width: 100%;
            padding: 20px;
            padding-top: 0px;
            .big-title {
                // font-size: 20px;
                font-weight: 600;
                color: #333333;
                // margin: 30px 0;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 24px;
            }
            .small-title {
                // font-size: 16px;
                font-weight: 600;
                color: #333333;
                // margin-bottom: 24px;
                font-size: 16px;
                line-height: 20px;
                margin-bottom: 20px;
                margin-top: 28px;
            }
            .mini-title {
                font-size: 14px;
                font-weight: 600;
                color: #333333;
                margin-bottom: 24px;
            }
            p {
                font-size: 14px;
                color: #666a75;
                overflow: hidden;
                line-height: 22px;
                white-space: pre-wrap;
                // white-space: normal;
                word-break: break-all;
            }
            .attr-table {
                font-size: 14px;
                width: 100%;
                tr {
                    border: 1px solid #eee;
                    td {
                        width: 50%;
                        vertical-align: top;
                        border: 1px solid #eee;
                    }
                }
                .table-item {
                    padding: 12px 16px;
                    display: flex;
                    line-height: 20px;
                    .lab {
                        width: 160px;
                    }
                    .table-info {
                        flex: 1;
                        white-space: pre-wrap;
                    }
                }
            }
            .version-tabs {
                display: flex;
                .tab {
                    font-size: 12px;
                    color: #575d6c;
                    cursor: pointer;
                    padding: 7px 13px 6px;
                    border: 1px solid transparent;
                    border-bottom: none;
                    transition: all .1s ease;
                }
                .active {
                    color: #526ecc;
                    border-color: #eee;
                }
            }
            .sence-table {
                width: 100%;
                .lab {
                    font-size: 12px;
                    width: 220px;
                    word-break: break-all;
                }
                tr,td {
                    border: 1px solid #eee;
                }
                th {
                    background-color: #f5f6f6;
                    padding: 6px 18px;
                    color: #333;
                }
                td {
                    padding: 12px 26px;
                }
                .version-time {
                    color: #999;
                    margin-top: 3px;
                    // display: inline-block;
                }
            }

            .advantages-tags {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                li {
                    &:nth-child(odd) {
                        margin-right: 10px;
                    }
                    &:nth-child(even) {
                        margin-left: 10px;
                    }
                    // &:first-child{
                        margin-bottom: 20px;
                    // }
                    // height: 155px;
                    width: calc(50% - 10px);
                    background-color: #f5f6f6;
                    padding: 25px 20px 12px;
                    box-sizing: border-box;
                    position: relative;
                    .num {
                        position: absolute;
                        top: -16px;
                        right: 60px;
                        height: 33px;
                        width: 25px;
                        background-repeat: no-repeat;
                    }
                    .num1 {
                        background-image: url('../../../assets/image/gorithm/1.png');
                    }
                    .num2 {
                        background-image: url('../../../assets/image/gorithm/2.png');
                    }
                    .num3 {
                        background-image: url('../../../assets/image/gorithm/3.png');
                    }
                    .num4 {
                        background-image: url('../../../assets/image/gorithm/4.png');
                    }
                    .title {
                        font-weight: 700;
                        color: #252b3a;
                        font-size: 16px;
                        margin-bottom: 10px;
                        line-height: 20px;
                    }
                    .desc {
                        color: #666a75;
                    }
                }
            }

            .apps {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                .app {
                    width: 50%;
                    padding: 10px 20px;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    border: 1px solid #eee;
                    img {
                        margin-right: 10px;
                    }
                    .title {
                        font-weight: 700;
                        color: #252b3a;
                        font-size: 16px;
                        margin-bottom: 10px;
                        line-height: 20px;
                    }
                    .desc {
                        color: #666a75;
                    }
                }
            }
        }
    }
    .additional-list {
        &+.additional-list {
            margin-top: 20px;
        }
        float: left;
        width: 270px;
        margin-left: 20px;
        background-color: #ffffff;
        .title {
            white-space: nowrap;
            height: 50px;
            line-height: 50px;
            padding-left: 20px;
            border-bottom: 1px solid #E6E6E6;
        }
        .company-logo {
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: 1px solid #E6E6E6;
            height: 128px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .recommend-list {
            padding: 20px;
            
            .recommend-item {
                display: flex;
                padding-bottom: 10px;
                border-bottom: 1px solid #E6E6E6;
                &+.recommend-item {
                    margin-top: 10px;
                }

                .recommend-item-img {
                    width: 56px;
                    height: 56px;
                    img {
                        width: 56px;
                        height: 56px;
                    }
                }
                .recommend-item-content {
                    margin-left: 10px;
                    width: calc(100% - 56px - 10px);
                    .recommend-item-title {
                        p {
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        font-weight: 600;
                        font-size: 14px;
                    }
                    .recommend-item-introductory {
                        display: -webkit-box;
                        overflow: hidden;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        color: #666666;
                        font-size: 14px;
                    }
                }
            }
            
        }
    }
    .details {
        padding: 30px;
        background-color: #ffffff;
        .video {
            display: inline-block;
            vertical-align: top;
            width: calc(100% - 750px);
            padding-left: 28px;
            .video-content {
                width: 100%;
                height: 321.75px;
                video {
                    height: 100%;
                    width: 100%;
                }
                img {
                    height: 100%;
                    width: 100%;
                }

            }
            .video-selector {
                margin-top: 20px;
                .video-selector-options {
                    height: 48px;
                    .option {
                        display: inline-block;
                        height: 100%;
                        border: 2px solid transparent;
                        img {
                            // width: 80px;
                            height: 100%;
                        }
                        &.active {
                            border: 2px solid #c7000a6c;
                        }
                    }
                    .option+.option {
                        margin-left: 10px;
                    }
                }
            }
            .video-tags {
                margin-top: 20px;
                .tag {
                    display: inline-block;
                    font-size: 12px;
                    color: #333333;
                    &+.tag {
                        margin-left: 100px;
                    }
                }
            }
        }
        .text {
            display: inline-block;
            width: 750px;
            .text-img {
                display: inline-block;
                vertical-align: top;
                width: 80px;
                height: 80px;
                img {
                    width: 80px;
                    height: 80px;
                }
                // float: left;
            }
            .text-content {
                display: inline-block;
                vertical-align: top;
                width: calc(100% - 80px);
                padding-left: 20px;
                // float: left;
                .text-content-title {
                    color: #333333;
                    font-size: 18px;
                    font-weight: 600;
                    &:hover {
                        color: blue;
                        cursor: pointer;
                    }
                    span {
                        display: inline-block;
                        background-color: #252B3A;
                        padding: 0 8px;
                        height: 28px;
                        line-height: 28px;
                        font-weight: 400;
                        color: #D6AF76;
                        font-size: 12px;
                        margin-right: 12px;
                    }
                }
                .supplier {
                    margin-top: 16px;
                }

                .text-content-introductory {
                    margin-top: 10px;
                    white-space: pre-line;
                }
            }
            .details-button {
                margin-top: 30px;
                width: 750px;
                height: 140px;
                background-image: url("data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/4QBaRXhpZgAATU0AKgAAAAgAAgESAAMAAAABAAEAAIdpAAQAAAABAAAAJgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAACiqADAAQAAAABAAAAhgAAAAAAAP/tACxQaG90b3Nob3AgMy4wADhCSU0EJQAAAAAAENQdjNmPALIE6YAJmOz4Qn7/2wBDAAIBAQIBAQICAgICAgICAwUDAwMDAwYEBAMFBwYHBwcGBwcICQsJCAgKCAcHCg0KCgsMDAwMBwkODw0MDgsMDAz/2wBDAQICAgMDAwYDAwYMCAcIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCACGAooDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD9zKKKK+bPYCiiigAooooAKKcI2borH8KDEy/wt+VFmA2iiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiipLS2a7nVF79T6Cmk27IG7asm03Tvtj7m/1a9ff2rY4iUKowB0HpSRotvEqr0UYFAG416dKmqat1OGc3J3BV3GlY8UE7RTcZrQkAM/hRQaQnNAATuOKXoKANopOv0ouADnn8qRmxSs22mVmAU0nefpQx3HAp33BQaCE7RUFzaC7T/aHQ1Njc1DNiplZqzBNrYx5IzE5VuoptaF/beam4feX9az64Jx5WdUZXVwoooqCgooooAKKKuWdphdzdewPaqjFt2E3YigsWk5b5V/WrUVskfQDjuaeBk0E10RgkZOTYE0jNtpScCmAbjVEiGIS/eX86rzWXPyH8DVpjgYppOBUyinuNSaM9l2naaKuSxef9fWqbLtbBrnlGxrGVwoooqSgooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArX0e2+z23mN96T+VZltD9ouFT+8efpW51/kK68LHXnZhXlpYPvGnE7BR91aaTk12nMHWgnmg8UE4/pQAE0AYpAKDyaAA8mlJ2ijoKjJzWYATk01z2pWOKFGBQaABtFIfnNDNuNH3VpN2ACdoptB60xmzUFLuDNuqhfQeTL/stzWgq1Fdx/aIyO/UVlUV0XCVnczqKmFhJ/s/nTv7Ok9V/Oubkl2NeZFeiiipKJrOHzpefuryavdTUNimyAf7XJqf7tdNONkYyd2J0FBOBQTgUwnJqyQ++aUnAxQflFNoAKax3GhmzQq7RSbGKBsFQXSbxu9KlZt1Iahq5Ue5ToqwLVfemtAoP8X51jyMvmRDRUhgqMjBqSgooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKALuix77hm/ujH51qgbBVHQExDI3+1irrNmvSw6tBHHW1kITmjpRnFBNbGYE4FIooHNKTigBCecUo4FAGBTGbNQ2AM2TTWbApScU0Dcc0i1oCr3oZs0M2KFG0UDADYtNJyaVjk0xmxWY0DtQq5pFXdSu2alse4jNmkoFBOTUlBTfMods03FAGfRVxdOXHzM34Up05Mfeb865/ZyNuZE0Q2RL9BS0YxTXbNdBiIzZNKBtHvQo2jNNJyaAAnJprtQzYoVaAFVcUjNmh2ppOBWZSAnFAGKAKRjgUFCM2KaBk0AZNBqZMANI6hhzSk4FNJ3mpKSInXaaSpnA24qGsygooooAKKKKACiiigAooooAKKKKACiiigAooqxZ2DXZ/ur3aqjFt2QnJJXZXA3HjmrUOkzS9QEHvWlb2kdqvyrz3J6mpK64YVfaMJVuxRTQ1/ikb8Binf2JF/ek/MVcozmtvYw7GftJdyg+hqfuyH8RVafSpYD03D/Z5rYLYoxiolh4dBqtJHPkYP0orYu7SO66rhv7w61mXFq1q3zfga5KlFxN41FIiooorI0CiiigAooooAKKKKACiiigAooooAKKKKACiiigAoop0ULTvtRSzegoAbRWjb6CSMyNt/2V/xqyumwQjhAx/2ua6I4Wb1ehi60VsYtFb0dtGP+WaD/gND2sTf8s4/++RV/VX3J+sLsV9G4s/qxNWh/kUkcaxLhVCr6ClJya64R5YpGMpXdwJpB8xo+8falJwKokCcCgCkA5pGbFS2AO1NJwKKb98+1SVFABvNKzYoJ2ikUZOaCgVe9IzZNK7ZppOBWY1qIxwKYBuNH3jTidopN2HuDHAxTRRQetQUGc012pWbApqrmgBVGOaTcaCc0lAEgFBOTQTmms2KAB2oVe9CjNIzZNACFs0jNtpScCmqNxzQAKuaGbFDtim1mVuFAGTR1oJwKChGOBTOpoJyaX7tTJgJ0FFFNZs1JSQMdxpfuLSAbRTScmpkygJyaY/WnMe1IwwtSA2iiigAooooAKKKKACiiigAooooAKKKdHGZZFVerHAoAm0+xN3Jz/q16+9a6J5ahQMAdAKbbwLbQqi9v1p/SvTo01BeZx1J8zDFBNFHWtTMOtIef89KM5/xoJ2ipbAPuims26kJzTSd3SpKUQLelJJGrxlWG7dS52CgDu1D8yjKurY20uP4T0NRVrXUX2mEr+XsayWXacHtxivPqQ5XodMJXQUUUVmWFFFFABRRRQAUUUUAFFFOSNpPuqzfQUANoqT7JN/zyk/75NNaNk+8rL9RT5WguNooqaxs2vZwi/Un0FEU27IG7asdp+nNfP8A3UXq1bMFtHbJtjXb79zT0RYI1RBhVoJxXqUaKgr9ThqVHN+QjHApoG40ffNKTtFaNkAzYGKaKOtB60hgTmkPPFKTQBigA6Ug5P8AKj7x9qCcCpbAGbAplBOTTWbccVJSQE7jinfdFIBtFJ980FAPnoZsDFBO2mk1DYATgVGTk0rNuNKBsFIryD7g96b1NBOTR0rMoM0jNgUpOKj+8aAFA3GhjxSsccU0nFAATgUzcaX7xp2KVx+o9mxTVXcaANxpWOOKYgds00nAoJwKbneaAADeaUnaKCdgphOTUNj3Ck60p5o6CkV5ATgUxjk0M26kHFJsYo4pKCcmms2KgpIHahV2ihFpGbJqZMoGbNNY4pScCkUVIAoxSO2aHam0AFFFFABRRRQAUUUUAFFFFABRRRQAVe0SDfM0n90YH1qjWto8eyzB/vEmtsPG8zOs7RLXSiijNekcYdKbjd9KXGTSM9S5AKzYphNDNTcbutSUkH3vpQWx0oLbuBR9360mygxt600nNBNNLbjUDsDNmqOoQ+XLu/vVeztqOeAXCYY4561lUXMrI0i7O5m0VbOnL/eP5UxrAj7rZ+tc/s5GvMivRTpIWi+8tNqCgooooAKtWekSXXzN+7X1PU1a0vSQqrLMPm6qp7fWrzNiuyjhrrmmc9StraJXh0yGDgLub1bmrB+UYFGdg96b0rrUUtkc7be4HgUjAMOcYpaTOaYEE+mQzDO3Z7rU2naf9ht/Vn5J9qEHmSqPertKnTjfmCU5WsQE4FR/eNSyx56UwDYKuRKF+4KYTk0E5NHQVJQUE4oJxSAUAKBikJ3UpNH3RUtgBO0VGTk0rHJprHAqSooRmxSqu0UiLihjmgoCd5oJ2Cj7o96aTk1LYATTGbJpXbNCjNSVtogAwM00nJpWbNJ0rMoO1BOKCaYzZNAATuNKflFH3PrTaACmk7jQx3HFLwtJuwxSdgpm40hOTRUD5SYnaKbRTWO6tCQJ3mnAbRQF2j+dMZt1Q2P0EJyaCfzoJopFeQU12zQ7U2k2MAKCc0E5oJwKgaQjNtpFXPNAG40O1JssGbNNJwKCcCmgbqgBQMmkZsUrNgUygAooooAKKKKACiiigAooooAKt2ukPMNz/Iv6mrGmad5aiSQfN1A9Ku12UcPdXmc9St0iV4tMhi/h3f73NSi1jx/q4/8Avmn0E/lXUoRWyMeZkMmnwyf8s1/DipI4xEgVeFXpTutBPNHKk7oXMxCcUAY5NH3RTS2aGxCs+aYWxSFucCjG2pLSsAXuaPvmjG6gtxUtjAnb0prNims2KAM9akpCfeNKTjpSE0dB/SobKExxQTQTipINOkuBuxtXsTTjFvRCcktyEnfRnaK0F0lFXlmP0obSoj3f860+rzI9pEzWPHNV5bXPzL+VacujMDlW3exqnMrRNtZSprGrTa+JGkZ9ihV3RrL7RL5jD5U6D1NQzw7+V+9Wxawi0tlT0HPuanD0rzu9kVVqWjZEjNSfdHvR05puc13tnIFHWjPNB5pDEPP0pGbJoZu1MPJrMqKJbP5p/YVaZs1VtG/e/hVkDiuin8JnPcOgqGYfN7VKxzTGXK/yolqJEXSgnAoJpPvVmWA5pSaCcUAUmwADFMZsmlds00nAqBoCcCmqMnJoA3HNDNgUFg7UAbBQvAzSM2TUyYCE5prtSs2KaBuNSVsCjJpWbNDHHFNAqGykFFGaazUgBmzQBtFIBjr/APrpCc0ABOTTWahmwKFGKBgF2ikZsmhmzTSazGu4E0bBSgYFJuFBREL5scr+XFKLzH8P61BRWPtJFcqLDXu7+HH4037X/s/rUNFHMw5UTC6/2f1oN3x939ahoo5mPlRJ5/t+tBn/ANmo6KOZhyok8/2/WmmXJ/8Ar02ilzMZJ53HSm+Z/s/rTaKQClsmlL/5zTaKAAnJooooAKKKKACiiigAooooAKtaXbfaLnLfdQZNVa1NGj22pb+8fzrajHmnZmdSVolyijpRXpHGGaBR0pD81ABndQTtFIzYppNQ2OwFs03O6j7/ANKC2OBSLDO0UAdzRjaOetNLZqXIBS2aYz0M2aMbaluxQAdz0pCdxpPvGjNZlC4xSM2KazYq1pdr5s25uic/jVRi5OyJlKyuyaw08RgSSD5uoB/hq4TRmmk16cYqCsjkk3J3YZpDSdaGNIEBOKhuLdblNrD8fSpDTSdtTKzVhmbHaeRfRo3TOQfXFXmGGpzxglWP3l6U1+cVhGnyp2NJScmNJzQeaCaTpTAKRmwMUE7RTGNQ2NATk0nXijPYUE44qWyx9s+2dfTpVt3rNL5bitCN96Bv7wrSlLoZ1I9Q60ZzRuyabWpmRsMtQTgUrnBpo5NZy0NAA70jtQzYFNrMaCm/fNBO8077tBYE7RTVGeaANxoZqlsAZs0xmwKUnFRk7mqSttQ6mnZ2ig/IPem1DY0FBNGeKRmxSGIzYpFFAGaGbNAAxyaazYpS2KaBuNAAq0O2aGamk4FZlICcUAYpAOc0jNigoHb0ptFLx71LkBWooorE0CiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArY0r/AI8I/wAf5miiunC/H8jGt8JYoPyiiiu85RBz1/CkY4oorMBp6U373Wiig0B2xx2oA2j60UVMgGk5NNc80UVJXQPun3ptFFZlICaRzgUUUAJt2+9ammLttV/2iSaKK6cL8ZlW+EmzkUHrRRXYzm6jcYH4U3NFFIoQ8mk6tRRWYDWOTTHfmiioZSEPApvQZooqJFDSeKaflWiipNAJxUbmiisxgeBU1lLtbZ7ZoopU2+YJbFnGTSUUV2mCI2OXPtQx4oorB7lEdNc4oopGiHKOKYTueiigBWO0U2iisyojHb5qVOlFFKWwdRpOTQeKKKgoKjJzRRQA5+OKbRRQAzq3NOJwtFFTIbGUnU0UVJYp6VGTk0UUnsAZoooqBo//2Q==");
                background-repeat: no-repeat;
                background-size: cover;
                padding: 0 30px;
                display: flex;
                align-items: center;
                .title {
                    width: calc(100% - 120px);
                    display: inline-block;
                    vertical-align: middle;
                    .top {
                        font-size: 14px;
                        color: #333333;
                    }
                    .bottom {
                        margin-top: 10px;
                        font-size: 12px;
                        color: #666666;
                    }
                }
                .button {
                    border-radius: 4px;
                    margin-left: 0px;
                    padding: 0 27px;
                    height: 46px;
                    line-height: 46px;
                    cursor: pointer;
                    vertical-align: middle;
                    display: inline-block;
                    color: #FFFFFF;
                    background-color: #c7000b;
                    border-color: #c7000b;
                }
            }
        }
    }
    .ai-nav-head {
        background-color: #ffffff;
        // width: 1410px;
        width: 100vw;
        position: fixed;
        top: 100px;
        left: 0;
        z-index: 1;
        box-shadow: 0px 3px 2px #cccccc40;
        // transition: 0.1s ease;
        .ai-nav-search {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px 0;
            .ai-page-title {
                font-size: 16px;
                font-weight: 600;
                color: #333333;
            }

            .search-box {
                display: flex;
                .search {
                    width: 500px;
                    height: 30px;
                    /deep/.el-input__inner {
                        height: 30px;
                        line-height: 30px;
                        border-radius: 0px;
                    }
                }
                .button {
                    height: 30px;
                    line-height: 30px;
                    background-color: #d30303;
                    color: #ffffff;
                    padding: 0 30px;
                }
            }
        }
    }
    @media (max-width: 991px) {
        .ai-nav-head {
            top: 75px;
            z-index: 100;
        }
    }
</style>